module.exports = __webpack_public_path__ + "img/youwriytt.5c70755c.png";